import { render, staticRenderFns } from "./SalabamVivamod.vue?vue&type=template&id=7fedb168&scoped=true"
import script from "./SalabamVivamod.vue?vue&type=script&lang=js"
export * from "./SalabamVivamod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fedb168",
  null
  
)

export default component.exports